/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * ZogoCredentialBase
 * auto generated base class for the model ZogoCredentialModel.
 */
export const ZogoCredentialModelBase = ModelBase.named('ZogoCredential')
  .props({
    __typename: types.optional(types.literal('ZogoCredential'), 'ZogoCredential'),
    access_token: types.union(types.undefined, types.string),
    expires_in: types.union(types.undefined, types.number),
    token_type: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ZogoCredentialModelSelector extends QueryBuilder {
  get access_token() {
    return this.__attr('access_token')
  }
  get expires_in() {
    return this.__attr('expires_in')
  }
  get token_type() {
    return this.__attr('token_type')
  }
}
export function selectFromZogoCredential() {
  return new ZogoCredentialModelSelector()
}

export const zogoCredentialModelPrimitives = selectFromZogoCredential().access_token.expires_in.token_type
